import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined, QuestionCircleFilled } from '@ant-design/icons'
import InboundListView from '@components/shared/inbounds/InboundListView'
import InboundConceptModal from '@shared/inbounds/InboundConceptModal'
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import Can from '@shared/permissions/Can'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { inboundService } from '@services/admin/inboundService'
import supplierService from '@services/admin/supplierService'

const AdminInboundList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  // useAdminNotification 是 .jsx，JSDoc `@returns {Object}` 讓 TS 把 return 看成空 Object；
  // 這裡 cast 成實際 runtime shape，不是 JSX 元件 cast。
  const { addJob } = useAdminNotification() as { addJob: (...args: any[]) => void }
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['inbounds', 'inbounds.list']}
        guideButton={
          <Tooltip title={t('concepts.inbounds.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <>
            <Can requiredPermission="inbounds:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="inbounds:write">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate('/inbounds/new')}
              >
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <InboundListView
        service={inboundService}
        supplierService={supplierService}
        role="admin"
        showMerchantColumn={false}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
      <InboundConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}

export default AdminInboundList
